import Container from '@/components/container'
import AppContent from '@/components/content'
import DefinitionLoader from '@/components/content/definitionLoader'
import Searcher from '@/components/content/searcher'
import { router } from '@/router'

export default {
  methods: {
    getDefaultCurrentContent (menu) {
      var currentContent = null
      if (menu) {
        menu.map((item) => {
          var defaultFound = false
          if (item.default) {
            currentContent = item
            defaultFound = true
          }
          if (defaultFound && item.subMenu) {
            var childCurrentContent = this.getDefaultCurrentContent(item.subMenu)
            if (childCurrentContent) {
              currentContent = childCurrentContent
            }
          }
        })
        if (!currentContent) {
          currentContent = this.getDefaultCurrentContent(menu[0].subMenu)
        }
      }
      return currentContent
    },
    getContent (menu, path, parent) {
      var content = {
        currentContent: null,
        detailContent: null,
        detailContentId: null
      }
      if (menu) {
        for (var i = 0; i < menu.length && content.currentContent === null; i++) {
          var menuUrl = menu[i].parentContextPath + menu[i].contextPath
          var menuUrlParams = menuUrl.split('/')
          var pathParams = path.split('/')

          var found = true
          var detailContentId = null
          if (menuUrlParams.length !== pathParams.length) {
            found = false
          } else {
            for (var j = 0; j < menuUrlParams.length && found; j++) {
              if (menuUrlParams[j] !== pathParams[j] && menuUrlParams[j].substr(0, 3) !== ':id') {
                found = false
              } else if (menuUrlParams[j].substr(0, 3) === ':id') {
                detailContentId = pathParams[j]
              }
            }
          }

          if (found) {
            // Detail content, load level 3 content as main level
            if (menuUrlParams.length > 4) {
              content.currentContent = parent
              content.detailContent = menu[i]
              content.detailContentId = detailContentId
            } else {
              content.currentContent = menu[i]
            }
          } else {
            if (content.currentContent === null && menu[i].subMenu) {
              var childContent = this.getContent(menu[i].subMenu, path, menu[i])
              if (childContent.currentContent) {
                content = childContent
              }
            }
          }
        }
      }
      return content
    },
    getDefaultParentMenuPath (parent, menu, path) {
      var menuParent = null

      for (var i = 0; i < menu.length && menuParent === null; i++) {
        var menuItem = menu[i]
        var menuUrl = menuItem.parentContextPath + menuItem.contextPath
        if (menuUrl === path) {
          // first search for search
          if ((menuItem.type.id === 'definition' || menuItem.type.id === 'template') && menuItem.type.modeView === 'new') {
            var menuEndName = menuItem.id.substr(menuItem.id.indexOf('-') + 1)
            for (var j = 0; j < menu.length && menuParent === null; j++) {
              var aux = menu[j]
              if (aux.type.id === 'search' && aux.id.substr(aux.id.indexOf('-') + 1) === menuEndName) {
                menuParent = aux
              }
            }
            if (menuParent === null) {
              menuParent = this.getDefaultParentMenuPath(menuItem, menuItem.subMenu, path)
            }
          } else {
            menuParent = parent
          }
        } else if (menuItem.subMenu) {
          menuParent = this.getDefaultParentMenuPath(menuItem, menuItem.subMenu, path)
        }
      }

      return menuParent
    },
    getMenuAppRoutes (menu) {
      var menuRoutes = null
      if (menu != null) {
        menuRoutes = []
        menu.map((item) => {
          var type = item.type

          if (type) {
            if (type.id === 'definition' || type.id === 'template' || type.id === 'workflow' || type.id === 'tree') {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: DefinitionLoader,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            } else if (type.id === 'search') {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: Searcher,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            } else if (type.id === 'content') {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: AppContent,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            } else {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: Container,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            }
          } else if (item.contextPath) {
            menuRoutes.push({
              path: item.contextPath,
              name: item.id,
              component: Container,
              props: item,
              children: this.getMenuAppRoutes(item.subMenu)
            })
          }
        })
      }
      return menuRoutes
    },
    loadDetailView (detailMenuId, detailIdValue, detailCodeValue) {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
      console.log('loadDetailView', detailMenuId, detailIdValue, router.currentRoute.path)
      if (detailIdValue && detailIdValue !== '') {
        var pushObj = {
          name: detailMenuId,
          params: { id: detailIdValue }
        }
        if (detailCodeValue && detailCodeValue !== '') {
          pushObj.query = { code: detailCodeValue }
        }
        router.push(pushObj).catch(() => {})
      }
    },
    getNewMenuOfSearcherOption (menu, searcherMenuId) {
      var result = null
      var searcherMenuLevel = this.getMenuLevel(menu, searcherMenuId)
      if (searcherMenuLevel) {
        var newMenuId = 'new-' + searcherMenuId.substr(searcherMenuId.indexOf('search-') + 7)
        var newMenu = null
        var found = false
        for (var i = 0; i < searcherMenuLevel.length && !found; i++) {
          var menuOption = searcherMenuLevel[i]
          if (newMenuId === menuOption.id) {
            found = true
            // check create action or external new path
            if (
              (!menuOption.type && menuOption.contextPath) || (menuOption.type && menuOption.type.actions && menuOption.type.actions.create)
            ) {
              newMenu = menuOption
            }
          }
        }
        result = newMenu
      }
      return result
    },
    getSearcherMenuOfNewOption (menu, newMenuId) {
      var result = null
      var newMenuLevel = this.getMenuLevel(menu, newMenuId)
      if (newMenuLevel) {
        var searcherMenuId = 'search-' + newMenuId.substr(newMenuId.indexOf('new-') + 4)
        var searcherMenu = null
        for (var i = 0; i < newMenuLevel.length && !searcherMenu; i++) {
          if (searcherMenuId === newMenuLevel[i].id) {
            searcherMenu = newMenuLevel[i]
          }
        }
        result = searcherMenu
      }
      return result
    },
    getMenuLevel (menu, menuId) {
      var result = null
      if (menu) {
        for (var i = 0; i < menu.length && !result; i++) {
          if (menu[i].id === menuId) {
            result = menu
          } else {
            result = this.getMenuLevel(menu[i].subMenu, menuId)
          }
        }
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/menu.js